import { AgGridVue } from 'ag-grid-vue';

export const ROWS_SELECTIONS = {
  SINGLE: 'single',
  MULTIPLE: 'multiple',
};

export default {
  components: {
    AgGridVue,
  },
  props: {
    rowData: {
      type: Array,
      default: () => [],
    },
    rowSelection: {
      type: String,
      default: 'single',
      validator: (value) => Object.values(ROWS_SELECTIONS).includes(value),
    },
    pagination: {
      type: Boolean,
      default: false,
    },
    itemsYaSeleccionados: {
      type: Array,
      default: () => [],
    },
  },
  created() {
    this.isRowSelectable = (params) => !!params.data;
  },
  mounted() {
    this.gridApi = this.gridOptions.api;
    this.gridColumnApi = this.gridOptions.columnApi;
  },
  data() {
    return {
      gridOptions: {
        suppressPropertyNamesCheck: true,
        localeText: {
          noRowsToShow: 'No hay filas para mostrar',
          contains: 'Contiene',
          notContains: 'No Contiene',
          equals: 'Es Igual',
          notEqual: 'No es Igual',
          startsWith: 'Comienza con',
          endsWith: 'Termina con',
          filterOoo: 'Filtrar',
          greaterThan: 'Mayor que',
          greaterThanOrEqual: 'Mayor o igual que',
          lessThan: 'Menor que',
          lessThanOrEqual: 'Menor o igual que',
          inRange: 'En el rango',
          inRangeStart: 'Desde',
          inRangeEnd: 'Hasta',
          blank: 'Vacío',
          notBlank: 'No vacío',
          andCondition: 'Y',
          orCondition: 'O',
        },
        enableCellTextSelection: true,
      },
      defaultColDef: {
        sortable: false,
        filter: true,
        floatingFilter: true,
        resizable: true,
        suppressMenu: true,
        //editable: false,
      },
      rowClassRules: null,
      gridApi: null,
      gridColumnApi: null,
      selectedRows: null,
      searchQuery: '',
    };
  },
  methods: {
    onGridReady(params) {
      this.gridApi = params.api;
      this.gridColumnApi = params.columnApi;
      params.api.sizeColumnsToFit();
    },
    onFirstDataRendered(params) {
      params.api.sizeColumnsToFit();
    },
    updateSearchQuery(val) {
      this.gridApi.setQuickFilter(val);
    },
    onSelectionChanged() {
      this.selectedRows = this.gridApi.getSelectedRows();
      this.rowSelection === ROWS_SELECTIONS.SINGLE
        ? this.$emit('seleccionarItem', this.selectedRows.length > 0 ? this.selectedRows[0] : null)
        : this.$emit('seleccionarItems', this.selectedRows);
    },
    toggleColumnVisibility(columnDefKey, keyValue, isVisible) {
      const columnDefs = this.columnDefs.map((columnDef) => {
        if (columnDef[columnDefKey] === keyValue) {
          return {
            ...columnDef,
            hide: !isVisible,
            autoHeight: isVisible,
          };
        }

        return columnDef;
      });

      this.gridApi?.setColumnDefs(columnDefs);

      if (!isVisible) {
        this.gridApi?.resetRowHeights();
      }

      this.gridApi?.redrawRows();
    },
  },
};
